import { Chip, Popper } from '@mui/material';
import { RadioFilter, SelectFilter, TextFieldsFilter } from './staticFiltersComponents';
import { useMemo, useState } from 'react';

import { AppUseIcon } from 'components/ui';
import DateRangeSeparatePickersFilter from './staticFiltersComponents/DateRangeSeparatePickersFilter';
import { IAppTableFilters } from 'services/AppTableFilters';
import { t } from 'utilities/TranslationUtils';

export const getColumnFilter = (filter: any) => {
  if (!filter) return <></>;

  const [anchorElement, setAnchorElement] = useState<null | HTMLElement>(null);

  const applyFilter = (value?: any) => {
    setAnchorElement(null);
    filter.onApply(value);
  };

  const getComponentByFilterType = useMemo(() => {
    return {
      textfields: () => <TextFieldsFilter filter={filter} onApply={applyFilter} />,
      select: () => <SelectFilter filter={filter} onApply={applyFilter} />,
      'date-range-separate-pickers': () => <DateRangeSeparatePickersFilter filter={filter} onApply={applyFilter} />,
      radio: () => <RadioFilter filter={filter} onApply={applyFilter} />,
    }[filter.type]?.();
  }, [filter.type]);

  return (
    <div className={`filter-button-and-popup `}>
      <button
        type='button'
        className='popup-activate-button mx-1 btn btn-transparent p-0'
        onClick={(event: React.MouseEvent<HTMLElement>) => {
          setAnchorElement(anchorElement ? null : event.currentTarget);
        }}
      >
        <AppUseIcon name='FilterIcon' height='17' width='16' />
      </button>
      {!!anchorElement && (
        <>
          <div className='backdrop' onClick={() => setAnchorElement(null)} />

          <Popper
            data-test={'filter-popper'}
            className={`${filter.className || ''}`}
            open={!!anchorElement}
            anchorEl={anchorElement}
            placement='bottom'
            onResize={() => setAnchorElement(null)}
            onResizeCapture={() => setAnchorElement(null)}
            nonce={Math.random().toString(36).substring(7)}
          >
            <div>{getComponentByFilterType}</div>
          </Popper>
        </>
      )}
    </div>
  );
};

export const getFilterChips = (appTableFiltersInstance: IAppTableFilters) => {
  return FilterChips(appTableFiltersInstance.filters.map((f) => ({ ...f, onRemove: appTableFiltersInstance.removeFilter })));
};

export const FilterChips = (filters: any[]) => {
  return (
    <div data-test='current-filters' className='current-filters'>
      {filters.length === 0 && (
        <span className='no-filters font-400 font-15 font-lato px-2'>{t('table.added_filters_will_appear_here')}</span>
      )}
      {filters?.map((f, index) => FChip(f, index))}
    </div>
  );
};

const FChip = (filter: any, index: number) => {
  return (
    <div key={index} className='current-filter overflow-ellipsis' title={filter.label}>
      <Chip
        id={`filter-chip-${filter?.id}-${index}`}
        key={index}
        label={filter.label}
        // color='#414141'
        onDelete={() => filter.onRemove(filter)}
      />
    </div>
  );
};
